import { isShipiumEmail } from '~/utils/regex';
import { PARTNER_VIEW_HEADER_KEY } from '~/hooks/SessionContext';

export const deriveIsShipiumAdmin = (email?: string): boolean =>
  isShipiumEmail(email) && !localStorage.getItem(PARTNER_VIEW_HEADER_KEY);
